import { PDFPage } from "pdf-lib";
import { isNilOrEmpty } from "ramda-adjunct";
import { CommonDrawOptions, DocumentPlaceholder } from "../types";
import { scaleIntoBox, strToUint8Array } from "../utils";

export interface ImagePlaceholderOptions {
  image: string;
  format: "image/png" | "image/jpg" | "image/jpeg";
}

export const imageDraw = async (
  page: PDFPage,
  placeholder: DocumentPlaceholder<ImagePlaceholderOptions>,
  { pdfDoc }: CommonDrawOptions
) => {
  if (isNilOrEmpty(placeholder.options.image)) {
    throw new Error("Image placeholder should have image");
  }
  const imageBytes = await strToUint8Array(placeholder.options.image);

  const image = placeholder.options.format === "image/png" ? pdfDoc.embedPng(imageBytes) : pdfDoc.embedJpg(imageBytes);
  const imageData = await image;

  const imageDimension = { width: imageData.width, height: imageData.height };

  const boxPxWidth = placeholder.width * page.getSize().width;
  const boxPxHeight = placeholder.height * page.getSize().height;

  const { width, height } = scaleIntoBox(imageDimension, {
    width: boxPxWidth,
    height: boxPxHeight,
  });

  const x = placeholder.x * page.getSize().width + (width < boxPxWidth ? boxPxWidth / 2 - width / 2 : 0);
  const y =
    page.getSize().height -
    placeholder.y * page.getSize().height -
    height -
    (height < boxPxHeight ? boxPxHeight / 2 - height / 2 : 0);

  page.drawImage(imageData, {
    x: x,
    y: y,
    width: width,
    height: height,
  });
};
